import React, { useMemo } from "react";

const COLORS = ["#4BB34B", "#FFAD5C", "#E54746", "#E8E6EF"];
const RADIUS = 50;

const getCoordinates = (percent, radius) => {
  const angle = 2 * Math.PI * percent;
  return [Math.cos(angle) * radius, Math.sin(angle) * radius];
};

const createArc = (startPercent, endPercent, radius) => {
  const [startX, startY] = getCoordinates(startPercent, radius);
  const [endX, endY] = getCoordinates(endPercent, radius);
  const largeArcFlag = endPercent - startPercent > 0.5 ? 1 : 0;

  return `
    M 0 0
    L ${startX} ${startY}
    A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY}
    L 0 0
  `;
};

const CircularStats = ({ summary = {} }) => {
  const data = useMemo(
    () => [
      { name: "On Track", value: summary?.on_track_projects || 0 },
      { name: "Warranty", value: summary?.in_warranty_projects || 0 },
      { name: "Delayed", value: summary?.delayed_projects || 0 },
      { name: "Completed", value: summary?.completed_projects || 0 },
    ],
    [summary]
  );

  const total = useMemo(
    () => data.reduce((sum, item) => sum + item.value, 0),
    [data]
  );

  let startPercent = 0;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <svg width="70" height="70" viewBox="-55 -55 110 110">
        {total > 0 &&
          data.map((item, index) => {
            if (item.value === 0) return null;

            const endPercent = startPercent + item.value / total;
            const path = createArc(startPercent, endPercent, RADIUS);
            startPercent = endPercent;

            return (
              <path
                key={index}
                d={path}
                fill={COLORS[index % COLORS.length]}
                stroke="white"
                strokeWidth="2"
              />
            );
          })}
        <circle cx="0" cy="0" r="38" fill="white" />
      </svg>
      <div style={{ marginLeft: "15px" }}>
        {data.map(
          (item, index) =>
            item.value > 0 && (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: COLORS[index % COLORS.length],
                    marginRight: "8px",
                  }}
                ></div>
                <span
                  style={{
                    color: "#0D0D0E",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  {item.name}
                </span>
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default React.memo(CircularStats);
